import { SET_THEME } from "redux/actions/theme-actions";

const initialState = {
  activeTheme: "waya", // default to light
};

const ThemeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME:
      return { ...state, activeTheme: action.payload };
    default:
      return state;
  }
};

export default ThemeReducer;